import PodcastEpisodes from './PodcastEpisodes';
import PodcastEpisodesSkeleton, {
  PodcastEpisodesSkeletonProps,
} from './PodcastEpisodesSkeleton';

export default PodcastEpisodes;
export { PodcastEpisodesSkeleton };
export type { PodcastEpisodesSkeletonProps };
